import { render } from "./CorrectTwoView.vue?vue&type=template&id=77ae0184&ts=true"
import script from "./CorrectTwoView.vue?vue&type=script&lang=ts"
export * from "./CorrectTwoView.vue?vue&type=script&lang=ts"

import "./CorrectTwoView.vue?vue&type=style&index=0&id=77ae0184&lang=scss"

import exportComponent from "C:\\vue项目\\fushuliang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__